export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "group": {
          "documents": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pièces justificatives"])},
          "circumstances": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Circonstances"])},
          "personal_information": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations personnelles"])}
        },
        "missing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["· absente"])}
      },
      "en": {
        "group": {
          "documents": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supporting documents"])},
          "circumstances": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Circumstances"])},
          "personal_information": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Personal information"])}
        },
        "missing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["· missing"])}
      }
    }
  })
}
